export const INVALID_URL_KEY = 'validation.invalidUrl';

export const validUrl = (value: string) => {
  if (value === undefined || value === '' || value === null) {
    return undefined;
  }

  let url;
  try {
    url = new URL(value);
  } catch (_) {
    return INVALID_URL_KEY;
  }

  return url.protocol === 'http:' || url.protocol === 'https:' ? undefined : INVALID_URL_KEY;
};
